var map = {
	"./avon.jpg": 2600,
	"./dal-schedule-builder.jpg": 3328,
	"./dalcs.jpg": 5938,
	"./github-pinner.jpg": 8540,
	"./joinly.jpg": 6778,
	"./magic-upload.jpg": 4762,
	"./onlne.jpg": 9743,
	"./snack-track.jpg": 346,
	"./space-invaders.jpg": 9340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4026;